import React from 'react'
import { accent, accentLight, borderDefault } from './styles'

function PlacementZone({ index, isSelected, onClick, label }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '8px 12px',
        border: `2px dashed ${isSelected ? accent : borderDefault}`,
        borderRadius: '8px',
        backgroundColor: isSelected ? accentLight : 'transparent',
        color: isSelected ? accent : '#9ca3af',
        fontSize: '0.85rem',
        fontWeight: '600',
        cursor: 'pointer',
        marginBottom: '12px',
        width: '100%',
        transition: 'all 0.15s ease',
        fontFamily: 'inherit',
      }}
    >
      {label || '▼ Place here'}
    </button>
  )
}

export default PlacementZone
